import { Request, Response, NextFunction } from 'express';
import { Container } from 'typedi';
import { jsonStatus, status } from '../../../utils/helpers/api.responses';
import { pick, removenull } from '../../../utils/helpers/utilities.services';
import { RatingService } from '../services/rating.service';
import { HttpException } from 'utils/exceptions/httpException';

export class RateController {
    public rateService = Container.get(RatingService);

    public createRate = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { userId } = req.params;
            const { rating, feedback } = req.body;
            const t = req.t;
            const raterId = req.user._id;
            const ratingData = await this.rateService.createRating(userId, raterId, rating, t, feedback);
            res.status(status.Create).json({
                status: jsonStatus.Create,
                message: t('Rating.created'),
                data: ratingData,
            });
        } catch (error) {
            next(error);
        }
    };

    public getAllRatings = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t;
            const {
                page = 1,
                limit = 10,
                search = "",
                sortBy = "createdAt",
                sortOrder = "desc",
                userId,
                ...filters
            } = req.query;
            const parsedUserId = typeof userId === 'string' ? userId : undefined;

            const result = await this.rateService.getAllRatings({
                filters: { userId: parsedUserId, ...filters },
                page: parseInt(page as string),
                limit: parseInt(limit as string),
                search: search as string,
                sortBy: sortBy as string,
                sortOrder: sortOrder as string,
                t,
            });
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Rating.ratings') }),
                data: result.data,
                total: result.total,
                page: result.page,
                totalPage: result.totalPages,
            });
        } catch (error) {
            next(error);
        }
    };
    public getRatingByUserId = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const t = req.t;
            const userId = req.params.userId;

            if (!userId) {
                throw new HttpException(status.BadRequest, t('General.required', { field: 'userId' }));
            }

            const ratings = await this.rateService.getRatingByUserId({ userId, t });

            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Rating.ratings') }),
                data: ratings,
            });
        } catch (error) {
            next(error);
        }
    };


    public getRatingById = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { id } = req.params;
            const t = req.t;
            const userId = req.user._id;
            const rating = await this.rateService.getRatingById(id, userId, t);
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.get_success', { field: t('Rating.rating') }),
                data: rating,
            });
        } catch (error) {
            next(error);
        }
    };

    public updateRating = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { id } = req.params;
            const updates = pick(req.body, ['rating', 'feedback']) as {
                rating?: number;
                feedback?: string;

            };
            removenull(updates);
            const t = req.t;
            const updatedBy = req.user._id;
            const ratingData = await this.rateService.updateRating(id, updates, updatedBy, t);
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.update_success', { field: t('Rating.rating') }),
                data: ratingData,
            });
        } catch (error) {
            next(error);
        }
    };

    public deleteMultipleRatings = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { ids } = req.body;
            const t = req.t;
            const deletedBy = req.user._id;
            const result = await this.rateService.deleteMultipleRatings(ids, deletedBy, t);
            res.status(status.OK).json({
                status: jsonStatus.OK,
                message: t('General.delete_success', { field: t('Rating.ratings') }),
                data: result,
            });
        } catch (error) {
            next(error);
        }
    };
}